import { render, staticRenderFns } from "./TournamentTabText.vue?vue&type=template&id=71ea37ba&"
import script from "./TournamentTabText.vue?vue&type=script&lang=js&"
export * from "./TournamentTabText.vue?vue&type=script&lang=js&"
import style0 from "./TournamentTabText.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFlex})


/* hot reload */
if (module.hot) {
  var api = require("/Users/finnkelly/Code/Go Remote/remote-chat-finn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71ea37ba')) {
      api.createRecord('71ea37ba', component.options)
    } else {
      api.reload('71ea37ba', component.options)
    }
    module.hot.accept("./TournamentTabText.vue?vue&type=template&id=71ea37ba&", function () {
      api.rerender('71ea37ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Tournament/TournamentTabText.vue"
export default component.exports